// Loader.js
import React from 'react';
import '../assets/css/style.css';

const Loading = () => {
  return (
    <div style={loaderContainerStyle}>
      <div style={loaderStyle}></div>
      <p>Loading...</p>
    </div>
  );
};

const loaderContainerStyle = {
  textAlign: 'center',
};

const loaderStyle = {
  width: '50px',
  height: '50px',
  border: '4px solid rgba(255, 255, 255, 0.3)',
  borderTop: '4px solid #3498db', /* Blue color for the loader */
  borderRadius: '50%',
  animation: 'spin 1s linear infinite', /* CSS animation for rotation */
  marginBottom: '10px',
};

export default Loading;
